import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { ClienteGrupoEconomico } from './cliente-grupo-economico';

@Injectable({
    providedIn: 'root'
})
export class ClienteGrupoEconcomicoHttpService {
    resource = 'cliente';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /**
     * Carrega o grupo econômico do cliente e os demais clientes deste grupo econômico.
     * Caso o cliente não possuir um grupo econômico, então retorna sem um grupo econômico definido com somente o próprio cliente adicionado
     */
    load(idCliente: number): Observable<ClienteGrupoEconomico> {
        return this.customHttp.get<ClienteGrupoEconomico>(`${this.pathApi}/${idCliente}/grupoeconomico`);
    }
}
